module.exports = __webpack_public_path__ + "img/Mina.5570ed0d.jpg";